<template>
  <toggle-details>
    <div
      slot-scope="{ opened, toggle }"
      class="add-ons-taxes-overview"
    >
      <button
        class="add-on-activator"
        :class="{'--opened': opened}"
        aria-label="Toggle details"
        :aria-expanded="opened ? 'true' : 'false'"
        @click="toggle"
        @enter="toggle"
        @space.prevent="toggle"
      >
        <div class="add-ons-taxes-overview-title">
          {{ addOnsComponentData.AddOnsTitle }}
        </div>
        <div class="add-ons-taxes-overview-total">
          {{ getDisplayPrice({ price: addOnsTotalTaxes }) }}
        </div>
      </button>
      <transition name="expand-y">
        <ul
          v-if="opened"
          class="addons-list"
        >
          <li
            v-for="(addOn, index) in addOnsInCart"
            :key="`addon-${index}`"
            class="addon-item"
          >
            <div class="addon-item-header">
              <div class="addon-title">
                {{ addOn.addOnName }}
              </div>
              <div class="addon-total">
                {{ getDisplayPrice({ price: getTotalTaxPerAddOn(addOn) }) }}
              </div>
            </div>
            <ul class="addon-taxes">
              <li
                v-for="(taxes, taxDate) in addOn.addOnTax"
                :key="`tax-${taxDate}`"
                class="addon-tax"
              >
                <template v-if="addOn.data && addOn.data.selectedAddOnDates">
                  <template v-if="addOn.servicePricingType !== 'per-stay'">
                    <div class="addon-tax-date">
                      Date: {{ formatDate(taxDate) }}
                    </div>
                  </template>
                </template>
                <div class="addon-tax-quantity">
                  {{ addOnsComponentData.QuantityLabel }}: {{ getAddOnQuantity(addOn) }}
                </div>
                <template v-if="showGuestsQuantity(addOn)">
                  <div
                    v-if="addOn.adultQuantity"
                    class="addon-tax-quantity"
                  >
                    {{ addOnsComponentData.AdultLabel }}: {{ addOn.adultQuantity }}
                  </div>
                  <div
                    v-if="addOn.childQuantity"
                    class="addon-tax-quantity"
                  >
                    {{ addOnsComponentData.ChildLabel }}: {{ addOn.childQuantity }}
                  </div>
                </template>
                <div
                  v-for="(tax, taxIndex) in taxes"
                  :key="`tax-${taxIndex}`"
                  class="addon-tax-line"
                >
                  <div class="addon-tax-name">
                    {{ tax.taxLines }}
                  </div>
                  <div class="addon-tax-amount">
                    {{ getFormattedPrice(tax.price) }}
                  </div>
                </div>
              </li>
            </ul>
          </li>
        </ul>
      </transition>
    </div>
  </toggle-details>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import { formatDateZone } from '@utils/date-helpers'

  export default {
    name: 'AddOnTaxesOverview',
    computed: {
      ...mapState('auth', ['addOnsComponentData']),
      ...mapGetters('i18n', ['tc']),
      ...mapGetters('cart', ['addOnsInCart', 'addOnsTotalTaxes', 'getTotalTaxPerAddOn', 'getAddOnQuantity']),
      ...mapGetters('currency', ['getDisplayPrice']),
    },
    methods: {
      formatDate(date) {
        return formatDateZone(date, null, 'DD/MM/YYYY')
      },
      getFormattedPrice(price) {
        return this.getDisplayPrice({ price })
      },
      showGuestsQuantity(addOn) {
        return ['per-person', 'per-person-per-night'].includes(addOn.servicePricingType) && !addOn.airportAddOn
      },
    }
  }
</script>
